import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: theme.palette.grey[400],
      direction: "rtl",
      overflow: "hidden",
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: theme.palette.grey[400],
      overflow: "hidden",
    },

    topbarWrapper: {
      width: "100%",
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 100,
      background: theme.palette.common.white,
    },

    scrollContent: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: 0,
      boxSizing: "border-box",
      background: theme.palette.grey[400],
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    pageContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
    },

    detailsSection: {
      display: "flex",
      gap: 16,
      width: "100%",
      alignItems: "stretch",
    },

    topHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      padding: "12px 16px",
      boxSizing: "border-box",
      borderRadius: 4,
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
    },

    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },

    headerRight: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },

    collapseButton: {
      padding: 4,
      color: theme.palette.text.secondary,
    },

    userNameText: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette.text.primary,
    },

    headerAvatar: {
      width: "32px !important",
      height: "32px !important",
      fontSize: "12px !important",
      backgroundColor: `${theme.palette.profile.avatarBackground} !important`,
      color: `${theme.palette.profile.avatarText} !important`,
    },

    card: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      padding: 24,
      boxSizing: "border-box",
      borderRadius: 4,
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
    },

    cardTitle: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 16,
      fontWeight: 700,
      textAlign: "right",
      color: theme.palette.secondary.main,
    },

    field: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0,
    },

    label: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      fontSize: 12,
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      color: theme.palette.text.primary,
    },

    value: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "21px",
      letterSpacing: 0,
      textAlign: "right",
      color: theme.palette.secondary.main,
      wordBreak: "break-word",
    },

    detailValue: {
      textAlign: "left",
    },

    inputBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      height: 48,
      padding: "12px 16px 12px 8px",
      boxSizing: "border-box",
      borderRadius: 4,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
    },

    selectField: {
      width: "100%",
      margin: 0,
      "& .MuiOutlinedInput-root": {
        height: 48,
        boxSizing: "border-box",
        borderRadius: 4,
        backgroundColor: theme.palette.background.paper,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.divider,
      },
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        height: "100% !important",
        boxSizing: "border-box",
        padding: "12px 16px 12px 8px",
        fontFamily: theme.typography.fontFamily,
        fontWeight: 400,
        fontSize: 14,
        lineHeight: "21px",
        textAlign: "right",
        color: theme.palette.secondary.main,
      },
    },

    selectMenuItem: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "21px",
      textAlign: "right",
      justifyContent: "flex-end",
      color: theme.palette.secondary.main,
    },

    detailList: {
      display: "flex",
      flexDirection: "column",
      borderRadius: 4,
      overflow: "hidden",
    },

    detailRow: {
      display: "flex",
      flexDirection: "row",
      direction: "rtl",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "12px 8px",
      backgroundColor: theme.palette.grey[400],
    },

    emailLink: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },

    statusBadge: {
      display: "inline-flex",
      alignItems: "center",
      width: "fit-content",
      padding: "2px 10px",
      borderRadius: 4,
      fontSize: 12,
      fontWeight: 500,
    },

    statusActive: {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.dark,
    },

    statusInactive: {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.text.secondary,
    },
  })
);

export default useStyles